import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Quest/Portfolios/Domain/queries';
import Component from 'vue-class-component';

@Component
export default class PortfoliosQueries extends VueCqrs
{
	runPortfoliosPageQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildPortfoliosPageQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runPnlPageQueryV1(workspaceId: number, tchProjectId: number, viewDefId: string, pnlId: string, applyBenefitsConfidenceFactor: boolean, denomination: string)
	{
		const query = q.buildPnlPageQueryV1(workspaceId, tchProjectId, viewDefId, pnlId, applyBenefitsConfidenceFactor, denomination);
		this.$query(query);
	}

	runLinkeableTchProjectsByWorkspaceIdQueryV1(workspaceId: number)
	{
		const query = q.buildLinkeableTchProjectsByWorkspaceIdQueryV1(workspaceId);
		this.$query(query);
	}

	runPortfolioSettingsQueryV1(workspaceId: number, tchProjectId: number)
	{
		const query = q.buildPortfolioSettingsQueryV1(workspaceId, tchProjectId);
		this.$query(query);
	}

	runSpreadsheetImportMappingQueryV1(workspaceId: number, tchProjectId: number, blobId: string)
	{
		const query = q.buildSpreadsheetImportMappingQueryV1(workspaceId, tchProjectId, blobId);
		this.$query(query);
	}

	runPortfolioPlanningModuleStatusQueryV1(workspaceId: number, tchProjectId: number)
	{
		const query = q.buildPortfolioPlanningModuleStatusQueryV1(workspaceId, tchProjectId);
		this.$query(query);
	}


	runAllProjectsPageQueryV1(workspaceId: number, tchProjectId: number)
	{
		const query = q.buildAllProjectsPageQueryV1(workspaceId, tchProjectId);
		this.$query(query);
	}


	runProposedProjectsPageQueryV1(workspaceId: number, tchProjectId: number)
	{
		const query = q.buildProposedProjectsPageQueryV1(workspaceId, tchProjectId);
		this.$query(query);
	}

	runScheduledProjectsPageQueryV1(workspaceId: number, tchProjectId: number)
	{
		const query = q.buildScheduledProjectsPageQueryV1(workspaceId, tchProjectId);
		this.$query(query);
	}

	runStartedProjectsPageQueryV1(workspaceId: number, tchProjectId: number)
	{
		const query = q.buildStartedProjectsPageQueryV1(workspaceId, tchProjectId);
		this.$query(query);
	}

	runFinishedProjectsPageQueryV1(workspaceId: number, tchProjectId: number)
	{
		const query = q.buildFinishedProjectsPageQueryV1(workspaceId, tchProjectId);
		this.$query(query);
	}
}